<div id="contact-form-control-container">
    <div id="contact-form-tab">
        <div class="icon">
            <i class="bi bi-envelope-fill handle" id="contact-form-icon"></i>
        </div>
        <div class="modal-header">
            <h5 class="modal-title" [translate]="'contact_form.contact_us_in_english'"></h5>
        </div>
        <div class="modal-body">
            <div class="mt-3">
                <div [formGroup]="contactForm">
                    <select-extended-control controlName="type" iconClass="bi bi-list" labelText="contact_form.inquiry_type" [optionList]="typeList" [parentFormHelper]="contactForm" (change)="typeChange($event)"> </select-extended-control>
                    <text-extended-control controlName="subject" iconClass="bi bi-tag" labelText="contact_form.subject" placeholderText="contact_form.subject" [parentFormHelper]="contactForm"> </text-extended-control>
                    <text-extended-control controlName="senderName" iconClass="bi bi-person" labelText="contact_form.senderName" placeholderText="contact_form.senderName" [parentFormHelper]="contactForm"> </text-extended-control>
                    <text-extended-control controlName="senderEmail" iconClass="bi bi-envelope" labelText="contact_form.senderEmail" placeholderText="contact_form.senderEmail" [parentFormHelper]="contactForm"> </text-extended-control>
                    <textarea-extended-control [classList]="'textarea-resize-none'" controlName="body" iconClass="bi bi-chat-left-text" rows="6" placeholderText="contact_form.body" labelText="contact_form.body" [parentFormHelper]="contactForm"> </textarea-extended-control>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button id="send-button" (click)="sendMessage()">
                <span class="default" [translate]="'contact_form.send'"></span>
                <span class="success" [translate]="'contact_form.sending'"></span>
                <span class="error" [translate]="'contact_form.error'"></span>

                <div class="left"></div>
                <div class="right"></div>
            </button>
        </div>
    </div>
</div>
